<template>
  <virtual-list
    ref="vsl"
    class="virtual-list chat-conversation"

    :root-tag="'div'"
    :data-key="'__id'"
    :data-sources="messages"
    :data-component="MessageOne"

    @totop="onToTop"
    @tobottom="onToBottom"
    @scroll="onScroll"
  >
    <div
      slot="header"
      class="header"
    >
      <div
        v-show="loadingMessageTop"
        class="alert font-size-base border-0 text-center mb-0"
      >
        {{ $t('home.loading') }}
      </div>
      <div
        v-show="scrollTopFinished"
        class="alert font-size-base border-0 text-center mb-0"
      >
        <div class="text-muted">
          {{ $t('room.no_more_message') }}
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="footer"
    >
      <div v-show="loadingMessageBottom">
        {{ $t('home.loading') }}
      </div>
    </div>
  </virtual-list>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import VirtualList from 'vue-virtual-scroll-list';
import {eventBus} from "../../../main";
import MessageOne from './OneRoomComponents';
import {EMIT_ROOM_SCROLL_TO_MESSAGE, SCROLL_DIRECTION_BOTTOM, SCROLL_DIRECTION_TOP} from "../../../state/modules/room";

export default {
  name: 'RoomMessageList',
  components: {
    VirtualList,
  },
  data() {
    return {
      MessageOne,
      idLast: '',
      initDone: false,
      enableOnToBottom: true,
      skipOnToBottom: false,
      resizeObserver: undefined,
      lastResize: {
        height: null,
        offset: null,
      },
    };
  },
  computed: {
    ...mapState('room', [
      'loadingMessage',
      'scrollTopFinished',
      'scrollBottomFinished',
      'messages',
      'messageIdSearch',
    ]),
    ...mapGetters('room', [
      'isScrollDirectionTop',
      'isScrollDirectionBottom',
    ]),
    loadingMessageTop() {
      return this.isScrollDirectionTop && this.loadingMessage;
    },
    loadingMessageBottom() {
      return this.isScrollDirectionBottom && this.loadingMessage;
    },
  },
  watch: {
    messages(messages) {
      if (!this.initDone) return;
      if (!this.enableOnToBottom) return;
      if (!messages.length) return;

      const messageLast = messages.slice(-1).pop();
      //console.info('ListMessageChatComponent | messageLast = ', JSON.parse(JSON.stringify(messageLast)));

      const isMesAdd = (messageLast.id !== this.idLast);
      if (!isMesAdd) return;

      const vsl = this.$refs.vsl;
      const isScrollEnd = (vsl.getScrollSize() - vsl.getOffset()) === vsl.getClientSize();
      const isMesAddSelf = (messageLast.user_id === this.$store.state.auth.user.id);

      if (!isScrollEnd && !isMesAddSelf) return;

      //console.info('ListMessageChatComponent | isMesAdd = ', isMesAdd, ' | isScrollEnd = ', isScrollEnd, ' | isMesAddSelf = ', isMesAddSelf);

      this.idLast = messageLast.id;

      if (isMesAddSelf && !this.skipOnToBottom) {
        this.skipOnToBottom = true;
        this.$store.dispatch('room/fetchMessageOnNewMessage').then(() => {
          vsl.scrollToBottom();
          const check = setInterval(() => {
            if ((vsl.getScrollSize() - vsl.getOffset()) !== vsl.getClientSize()) return;
            clearInterval(check);
            this.skipOnToBottom = false;
          });
        });
      }
      vsl.scrollToBottom();
    },
  },
  mounted() {
    const vsl = this.$refs.vsl;

    const initDone = () => {
      this.initDone = true;
    };

    eventBus.$on(EMIT_ROOM_SCROLL_TO_MESSAGE, this.emitRoomScrollToMessage);

//    if (this.messages.length) {
//      this.idLast = this.messages.slice(-1).pop().id;
//    }
//
//    vsl.scrollToBottom();

    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this.$refs.vsl.$el);

    initDone();
  },
  beforeDestroy() {
    eventBus.$off(EMIT_ROOM_SCROLL_TO_MESSAGE);
  },
  methods: {
    onScroll() {
      if (!this.initDone) return;
      if (this.loadingMessage) return;

      //console.info('ListMessageChatComponent | onScroll');

      const {vsl} = this.$refs;

      if (!this.scrollTopFinished) {
        const is = vsl.getOffset() < 50;
        is && this.onToTop();
      }

      if (!this.scrollBottomFinished) {
        const is = ((vsl.getScrollSize() - vsl.getOffset()) - vsl.getClientSize()) < 50;
        is && this.onToBottom();
      }
    },
    onToTop() {
      if (!this.initDone) return;
      if (this.loadingMessage) return;
      if (this.scrollTopFinished) return;

      //console.info('ListMessageChatComponent | onToTop');

      const vsl = this.$refs.vsl;
      const {id: idBefore} = this.messages[0];

      this.$store.dispatch('room/fetchMessage', {
        direction: SCROLL_DIRECTION_TOP,
      }).then(() => {
        this.$nextTick(() => {
          const findIndex = this.messages.findIndex(({id}) => id === idBefore);
          let offset = vsl.virtual.getOffset(findIndex) - 32;
          if (offset < 0) offset = 0;
          //console.info('chat | onToTop | index = ', index, ' | offset = ', offset);

          vsl.scrollToOffset(offset);
        });
      });
    },
    onToBottom() {
      if (!this.initDone) return;
      if (this.loadingMessage) return;
      if (this.scrollBottomFinished) return;
      if (this.skipOnToBottom) return;

      //console.info('ListMessageChatComponent | onToBottom');

      this.enableOnToBottom = false;
      this.$store.dispatch('room/fetchMessage', {
        direction: SCROLL_DIRECTION_BOTTOM,
      }).then(() => this.enableOnToBottom = true);
    },
    onResize(en) {
      const {vsl} = this.$refs;
      if (!vsl) return;
      //vsl.updatePageModeFront();
      const isScrollEnd = (vsl.getScrollSize() - vsl.getOffset() - vsl.getClientSize());

      (isScrollEnd <= 22) && this.$nextTick(() => vsl.scrollToBottom());
    },
    emitRoomScrollToMessage({message_id}) {
      console.info('components/Room/List/ListRoomComponents | emitRoomScrollToMessage({', message_id, '})');

      const {vsl} = this.$refs;
      if (!message_id) {
        vsl.scrollToBottom();
        return;
      }

      const findIndex = this.messages.findIndex(({id}) => message_id === id);
      if (!findIndex) return;

      const offset = vsl.virtual.getOffset(findIndex);
      vsl.scrollToOffset(offset);
    },
  },
};
</script>

<style scoped>

</style>
